<div class="filterpanel-wr" [attr.aria-hidden]="!isOpen">
  @if (isOpen) {
    <form class="filterpanel-form" [formGroup]="form">
      <div class="filterpanel-grid">
        @for (field of fields; track field) {
          <!-- Text -->
          @if (field.filterType === filterTypes.Text) {
            <div class="filterpanel-field">
              <!-- <label class="filterpanel-label">{{ field.labelKey | translate }}</label> -->
              <input type="text" class="filterpanel-input" [formControlName]="field.controlName"
                [placeholder]="field.labelKey | translate" [attr.data-testid]="'filter-field' + field.controlName" />
            </div>
          }
          <!-- Numeric -->
          @if (field.filterType === filterTypes.Numeric) {
            <div class="filterpanel-field">
              <!-- <label class="filterpanel-label">{{ field.labelKey | translate }}</label> -->
              <input type="number" class="filterpanel-input" [formControlName]="field.controlName"
                [placeholder]="field.labelKey | translate" inputmode="decimal" [attr.data-testid]="'filter-field' + field.controlName" />
            </div>
          }
          <!-- Date (range) -->
          @if (field.filterType === filterTypes.Date) {
            <div class="filterpanel-field">
              <p-datepicker [formControlName]="field.controlName" placeholder="{{ field.labelKey | translate }}"dateFormat="dd-mm-yy" selectionMode="range" showClear="true" readonlyInput="true" appendTo="body" [attr.data-testid]="'filter-field' + field.controlName">
              </p-datepicker>
            </div>
          }
          <!-- Custom Dropdown -->
          @if (field.filterType === filterTypes.CustomDropdown) {
            <div class="filterpanel-field">
              <app-custom-dropdown
                [attr.data-testid]="'filter-field' + field.controlName"
                [fieldLabel]="(field.override?.fieldLabel ?? field.labelKey) | translate"
                [formControlName]="field.controlName"
                [isMultiselect]="field.isMultiselect ?? true"
                [options]="field.options ?? []"
                [optionLabel]="field.optionLabel ?? 'text'"
                [optionValue]="field.optionValue ?? 'id'"
                [translateOptionLabel]="field.override?.translateOptionLabel ?? false"
                [placeholder]="field.override?.placeholder ?? 'Select...'"
                [searchPlaceholder]="field.override?.searchPlaceholder ?? 'Search...'"
                [searchMode]="field.override?.searchMode ?? 'remote'"
                [showSearchbox]="field.override?.showSearchbox ?? true"
                [showClear]="field.override?.showClear ?? true"
                [compactUi]="field.override?.compactUi ?? true"
                [pageSize]="field.override?.pageSize ?? 10"
                [pageIndex]="field.override?.pageIndex ?? 1"
                [totalPages]="field.override?.totalPages ?? 1"
                [totalCount]="field.override?.totalCount ?? 0"
                [hasPreviousPage]="field.override?.hasPreviousPage ?? null"
                [hasNextPage]="field.override?.hasNextPage ?? null"
                (onLazyLoad)="onCustomDropdownLazyLoad(field.fieldKey, $event)"
              ></app-custom-dropdown>
            </div>
          }
        }
        <div class="filterpanel-actions">
          <button type="button" class="btn text-btn clear-btn" (click)="onResetFilters()" data-testid="btn-reset-filter">{{ 'FILTERS_PANEL.CLEAR' | translate }}</button>
          <button type="submit" class="btn text-btn apply-btn" (click)="onSubmitFilters()" data-testid="btn-apply-filter">{{ 'FILTERS_PANEL.APPLY' | translate }}</button>
        </div>
      </div>
    </form>
  }
</div>
